import { useCallback } from 'react';

import { useDispatch, useSelector } from 'app/store';
import CeilingHeightTile from 'modules/editor/components/Settings/CeilingHeightTile';
import {
  settingsCeilingHeightSelector,
  settingsCeilingHeightUpdate,
  settingsUnitSelector,
} from 'modules/settings/slice';
import { trackEventDebounced } from 'utils/googleAnalytics';

const CeilingHeightTileContainer = () => {
  const ceilingHeight = useSelector(settingsCeilingHeightSelector);
  const unit = useSelector(settingsUnitSelector);

  const dispatch = useDispatch();

  const onCeilingHeightChange = useCallback(
    (newCeilingHeight: number) => {
      dispatch(settingsCeilingHeightUpdate(newCeilingHeight));
      trackEventDebounced('settingsChange', { setting: 'ceilingHeight', newValue: newCeilingHeight });
    },
    [dispatch]
  );

  return <CeilingHeightTile ceilingHeight={ceilingHeight} onCeilingHeightChange={onCeilingHeightChange} unit={unit} />;
};

export default CeilingHeightTileContainer;
